const tenantFailList = r => require.ensure([], () => r(require('@/page/tenantMge/tenantFailList')), 'tenantFailList');

const tenantRouter={
  path:'',
  name:'保障房租户绑定',
  component:tenantFailList,
  meta:{icon:'tenantHouse',right:[],isShowMenu:true,keepAlive:false},
  children:[
    {path:'tenantFailList',component:tenantFailList,name:'保障房租户绑定失败列表',meta: {right:[],isShowMenu:true,keepAlive:false},},
  
  ]
};
export default tenantRouter;